export interface CalculateAmountParams {
  mode: 'total' | 'unit';
  qty?: string | number;
  quantity?: string | number;
  rate?: string | number;
  gross?: string | number;
  tax?: string | number;
  taxAmount?: string | number;
  gstAmount?: string | number;
  enableGst?: boolean;
  supportsUnits?: boolean;
}

export function calculateAmount({
  mode,
  qty,
  quantity,
  rate,
  gross,
  tax,
  taxAmount,
  gstAmount,
  enableGst = false,
  supportsUnits = true,
}: CalculateAmountParams): number {
  const q = Number(qty ?? quantity ?? 0);
  const rateVal = Number(rate ?? 0);
  const grossVal = Number(gross ?? 0);
  
  // Use direct GST amount (no percentage calculation)
  let finalTaxAmount = 0;
  if (enableGst) {
    if (gstAmount !== undefined && gstAmount !== "") {
      finalTaxAmount = Number(gstAmount);
    } else {
      // GST is enabled but no amount provided - this should be caught by validation
      finalTaxAmount = 0;
    }
  } else {
    // Fallback to legacy tax fields for backward compatibility
    finalTaxAmount = tax !== undefined ? Number(tax) : taxAmount ? Number(taxAmount) : 0;
  }

  // Calculate total amount
  if (mode === 'unit' && supportsUnits) {
    return q * rateVal + finalTaxAmount;
  } else {
    return grossVal + finalTaxAmount;
  }
}
